import { render, staticRenderFns } from "./PatternUserTableDeleteButton.vue?vue&type=template&id=928fbd7e&scoped=true&"
import script from "./PatternUserTableDeleteButton.vue?vue&type=script&lang=js&"
export * from "./PatternUserTableDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./PatternUserTableDeleteButton.vue?vue&type=style&index=0&id=928fbd7e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928fbd7e",
  null
  
)

export default component.exports